import { WikiActions } from './WikiActions'

/** Описание элементов в OWL 
 * description содержит информацию о графах. Для элементов графа фиксируется триплет
*/

const initialLWikiState = {
    state: "empty",
    wikis: [],
    nodes: [],
}
export const lwiki = (state = { ...initialLWikiState} , action) => {
  switch (action.type) {
    case "WikiActions.EMPTY":
      return{
        ...initialLWikiState,
      };
    case "WikiActions.LOAD_STARTED":
      return{
        ...state,
        state: "load",
    };
    case "WikiActions.LOAD_ERROR":
      return {
        ...initialLWikiState,
        error: action.error,
        state: "error",
    };
    case "WikiActions.NODES":
      return {
        ...state,
        nodes: action.nodes,
        state: "loaded",
    };
    case "WikiActions.SELECTED":
      return {
        ...state,
        page: action.page,
    };
    case "WikiActions.NODEPAGES": 
      const {nodes} = state;
      const np = [... nodes];
      for (let i=0; i<np.length; i++) {
        if (np[i].nodeId == action.nodeId){
          np[i].children = action.pages;
          break;
        }
      }
      //console.log("WikiReducer.js", state, np);
      return {
        ...state,
        nodes: np,
        state: "loaded",
    };
    default:
      return state;
  }
}
